import type { StyleProp, ViewStyle } from 'react-native';

import { Pill } from '@/components/Pill';

export interface BadgePillProps {
  /**
   * Server-provided bonus badge string ("2x"). null/undefined renders
   * nothing — the server owning the label is what lets a killed bonus
   * take its badges down with no OTA.
   */
  label: string | null | undefined;
  style?: StyleProp<ViewStyle>;
  testID?: string;
}

/**
 * Tiny payout-boost badge for share surfaces (Refer hero, deal pickers,
 * the Home promo banner). One component so "2x" looks identical
 * everywhere it appears. Thin wrapper over `Pill` — the electric-green
 * tone is the sanctioned high-emphasis combo on light AND dark cards.
 */
export function BadgePill({ label, style, testID }: BadgePillProps) {
  if (!label) return null;
  return (
    <Pill tone="green" style={style} testID={testID}>
      {label}
    </Pill>
  );
}
